import React, { useMemo, useState, useCallback } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { Button, Flex, Text, useModal } from '@pancakeswap-libs/uikit'
import { useMintBasicToken, useTransferOwnership, useRenounce, useBurn } from '../hooks/useSep20Factory'
import MintModal from './MintModal'
import BurnMoal from './BurnMoal'
import TransferOwnershipModal from './TransferOwnershipModal'

const Action = styled.div`
    padding-top: 5px;
`

interface CardActionsProps {
    token: any,
    account?: string
}

const CardActions: React.FC<CardActionsProps> = ({ token, account }) => {
    const TranslateString = useI18n();
    const { address, owner, isMintable, decimals } = token;
    const isOwner = account && owner && owner.toLowerCase() === account.toLowerCase();

    // Mint
    const onMintSubmit = useMintBasicToken(token.address)
    const onMintModalConfirm = async (amount) => {
        return onMintSubmit(new BigNumber(amount), token.decimals||0);
    };
    const [onMintStart] = useModal(<MintModal max={(new BigNumber(1e14)).toString()} token={token} onConfirm={onMintModalConfirm} />)
    
    // Transfer Ownership
    const onTransferOwnershipSubmit = useTransferOwnership(address);
    const onTransferOwnershipModalConfirm = async (newOwner) => {
        return onTransferOwnershipSubmit(newOwner);
    };
    const [onTransferOwnershipStart] = useModal(<TransferOwnershipModal onConfirm={onTransferOwnershipModalConfirm} />)

    // Renounce
    const [requestedRenounce, setRequestedRenounce] = useState(false)
    const onRenounce = useRenounce(address);
    const handleRenounce = useCallback(async () => {
        try {
            setRequestedRenounce(true)
            await onRenounce()
            setRequestedRenounce(false)
        } catch (e) {
            console.error(e)
        }
    }, [onRenounce])

    // Burn
    const tokenBalance = token.userBalance? token.userBalance.toFixed() : '0';
    const onBurnSubmit = useBurn(token)
    const onBurnModalConfirm = async (amount) => {
        return onBurnSubmit(new BigNumber(amount));
    };
    const [onBurnStart] = useModal(<BurnMoal max={tokenBalance} token={token} onConfirm={onBurnModalConfirm} />)

    return (
        <Action>
            <Button fullWidth onClick={onBurnStart}>
                {TranslateString(546,'Burn')}
            </Button>
            {
                isOwner && isMintable && (
                    <Button mt="8px" fullWidth onClick={onMintStart}>
                        {TranslateString(547,'Mint')}
                    </Button>
                )
            }
            {
                isOwner && isMintable && (
                    <Button mt="8px" fullWidth onClick={onTransferOwnershipStart}>
                        {TranslateString(400,'Transfer Ownership')} 
                    </Button>
                )
            }
            {
                isOwner && isMintable && (
                    <Button mt="8px" fullWidth onClick={handleRenounce} disabled={requestedRenounce}>
                        {TranslateString(548,'Renounce Ownership')}
                    </Button>
                )
            }
        </Action>
    );
}

export default CardActions
